import clsx from 'clsx'
import { Card, Form, Input, RichTextEditor } from 'components/common'

export interface TitleAndDescriptionProps {
  title?: string
  description?: string
  loading?: boolean
}

export interface TitleAndDescriptionFormValues {
  title: string
  description: string
}

export const ProductTitleAndDescription = ({
  title,
  description,
  loading = false,
}: TitleAndDescriptionProps): JSX.Element => (
  <>
    <Card shadow loading={loading}>
      <div className={clsx('mb-8')}>
        <Form.Item
          label="施設名"
          name="title"
          initialValue={title}
          className={clsx('block')}
          rules={[
            { required: true, message: '施設名は必須です。' },
            {
              type: 'string',
              min: 0,
              max: 100,
              message: '0文字以上、100文字以内で入力してください。',
            },
          ]}
        >
          <Input autoComplete="off" />
        </Form.Item>
      </div>
      <Form.Item
        label="説明"
        name="description"
        initialValue={description}
        rules={[
          {
            type: 'string',
            max: 1000,
            message: '1000文字以内で入力してください。',
          },
        ]}
      >
        <RichTextEditor defaultValue={description} />
      </Form.Item>
    </Card>
  </>
)
